export const agreement = 'agreement';

export const documentCategoryType = [agreement] as const;
export type DocumentCategoryType = typeof documentCategoryType[number];
